/* eslint-disable default-param-last */
import {
  CERTS_LIST_EXPORT_COLUMNS_TO_EXPORT,
  CERTS_LIST_EXPORT_STATUS,
  CERTS_LIST_RESET_EXPORT_STATUS,
  SET_CERT_LIST_ACTION_ERROR,
  SET_CERT_LIST_ACTION_IS_LOADING,
  SET_CERT_LIST_ACTION_STATUS,
  SET_CERT_LIST_COLUMN_OBJECTS_TO_BE_INCLUDED,
  SET_CERT_LIST_COLUMN_PICKER_ERROR,
  SET_CERT_LIST_COLUMN_PICKER_LIST,
  SET_CERT_LIST_COLUMN_PICKER_LIST_IS_LOADING,
  SET_CERTS_LIST_EMAIL_HISTORY,
} from '../types';

const INITIAL_STATE = {
  columnPickerList: null,
  objectsToBeIncluded: null,
  columnPickerListError: false,
  certsListExport: {
    isLoading: false,
    columnsToExport: null,
    certsListExportStatus: { exportStatus: '', timeStamp: 0, neoExport: false },
  },
  certsListDiscontinue: {
    status: null,
  },
  certListReassign: {
    status: null,
  },
  certsActionIsLoading: false,
  certsActionError: null,
  certsActionStatus: null,
  certsListEmailHistory: null,
};

const lineActionReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_CERT_LIST_COLUMN_PICKER_LIST:
      return {
        ...state,
        columnPickerList: action?.payload,
      };

    case SET_CERT_LIST_COLUMN_OBJECTS_TO_BE_INCLUDED:
      return {
        ...state,
        objectsToBeIncluded: {
          ...state.objectsToBeIncluded,
          ...action?.payload,
        },
      };
    case SET_CERT_LIST_COLUMN_PICKER_ERROR:
      return {
        ...state,
        columnPickerListError: action.payload,
      };
    case CERTS_LIST_EXPORT_COLUMNS_TO_EXPORT:
      return {
        ...state,
        certsListExport: {
          ...state.certsListExport,
          columnsToExport: action.payload,
        },
      };
    case CERTS_LIST_EXPORT_STATUS:
      return {
        ...state,
        certsListExport: {
          ...state.certsListExport,
          certsListExportStatus: action.payload,
        },
      };
    case CERTS_LIST_RESET_EXPORT_STATUS:
      return {
        ...state,
        certsListExport: {
          ...state.certsListExport,
          certsListExportStatus: {
            exportStatus: '',
            timeStamp: 0,
            neoExport: false,
          },
        },
      };
    case SET_CERT_LIST_COLUMN_PICKER_LIST_IS_LOADING:
      return {
        ...state,
        certsListExport: {
          ...state.certsListExport,
          isLoading: action.payload,
        },
      };
    case SET_CERT_LIST_ACTION_IS_LOADING:
      return {
        ...state,
        certsActionIsLoading: action.payload,
      };
    case SET_CERT_LIST_ACTION_ERROR:
      return {
        ...state,
        certsActionError: action.payload,
      };
    case SET_CERT_LIST_ACTION_STATUS:
      return {
        ...state,
        certsActionStatus: action.payload,
      };
    case SET_CERTS_LIST_EMAIL_HISTORY:
      return {
        ...state,
        certsListEmailHistory: action.payload,
      };
    default:
      return state;
  }
};

export default lineActionReducer;
